"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAccordionItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AccordionItemMixin = require("../../mixins/components/AccordionItemMixin");
var StyledAccordionItem = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "StyledAccordionItem",
  componentId: "c11n-8-107-0__sc-10xpf1n-0"
})(["", ""], _AccordionItemMixin.AccordionItemMixin);
exports.StyledAccordionItem = StyledAccordionItem;